export default __webpack_public_path__ + "assets/cleankitchen-mealkit/chicken_noodle.d322b7b4898dcc342042208d0e03f28b.webp";